import { useEffect, useState } from "react";
import { getDeviceLicenseSummary, type DeviceLicenseSummary } from "@/lib/api";

/** 自組織のライセンスの数。refreshKey を変えると取り直す。 */
export function useDeviceLicenseSummary(refreshKey: number): {
	summary: DeviceLicenseSummary | null;
	error: string | null;
} {
	const [summary, setSummary] = useState<DeviceLicenseSummary | null>(null);
	const [error, setError] = useState<string | null>(null);

	useEffect(() => {
		let cancelled = false;
		const load = async () => {
			try {
				const latest = await getDeviceLicenseSummary();
				if (cancelled) return;
				setSummary(latest);
				setError(null);
			} catch (err) {
				if (!cancelled)
					setError(err instanceof Error ? err.message : "ライセンスの数の取得に失敗しました。");
				throw err;
			}
		};
		void load().catch((err: unknown) => {
			console.error("ライセンスの数の取得に失敗しました", err);
		});
		return () => {
			cancelled = true;
		};
	}, [refreshKey]);

	return { summary, error };
}
